import { stringify as qsStringify } from 'query-string';
import type {
	WorkspaceId,
	CmdbObjectId,
	SchemaId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type { GraphObjectRequest } from '../types/graph.tsx';
import { getCmdbRestBaseUrl } from './index.tsx';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/graph
 */
const getCmdbGraphUrl = (workspaceId: WorkspaceId) => `${getCmdbRestBaseUrl(workspaceId)}/graph`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/graph/object/${objectId}
 */
export const getCmdbGraphObjectUrl = (
	workspaceId: WorkspaceId,
	objectId: CmdbObjectId,
	queryParams?: GraphObjectRequest,
) =>
	`${getCmdbGraphUrl(workspaceId)}/object/${objectId}${
		queryParams ? `?${qsStringify(queryParams)}` : ''
	}`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/graph/objecttype/${objectId}
 */
export const getCmdbGraphObjectTypeUrl = (
	workspaceId: WorkspaceId,
	objectId: CmdbObjectId,
	queryParams?: GraphObjectRequest,
) =>
	`${getCmdbGraphUrl(workspaceId)}/objecttype/${objectId}${
		queryParams ? `?${qsStringify(queryParams)}` : ''
	}`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/graph/objectschema/${schemaId}
 */
export const getCmdbGraphSchemaUrl = (workspaceId: WorkspaceId, schemaId: SchemaId) =>
	`${getCmdbGraphUrl(workspaceId)}/objectschema/${schemaId}`;
